import { render, staticRenderFns } from "./DialWatch.vue?vue&type=template&id=5e3e7ba4&"
import script from "./DialWatch.vue?vue&type=script&lang=js&"
export * from "./DialWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports